import { lazy } from 'react';
import Loadable from 'components/Loadable';
import DefaultLayout from 'layout/Default';
import { ProtectedRoute } from 'routes/RouteGuards';

const OffersList = Loadable(
  lazy(() => import('views/offers/OffersList'))
);

const OfferForm = Loadable(
  lazy(() => import('views/offers/OfferForm'))
);

const OffersRoutes = {
  path: '/offers',
  element: <ProtectedRoute />,
  children: [
    {
      element: <DefaultLayout />,
      children: [
        {
          index: true,
          element: <OffersList />
        },
        {
          path: 'add',
          element: <OfferForm />
        },
        {
          path: 'edit/:id',
          element: <OfferForm />
        }
      ]
    }
  ]
};

export default OffersRoutes;
